export default __webpack_public_path__ + "static/media/04.236ad342.jpg";